<template>
	<div>
		<div class="background1" style="height: 80%;">
			<div class="table" style="padding: 0">
				<div class="treeMes " style="padding: 0 10px 0 10px">
					<div class="chooseBox spaceBetween" style="height: 60px;border-bottom: 1px solid #DFDFDF">
						<div class="selectBox">
							<div>
								<div style="display: flex;align-items: center">
									<p style="margin-right: 20px">{{$t('label_524')}}</p>
									<el-radio v-model="radio" label="1" @change="selLables">{{$t('label_542')}}</el-radio>
									<el-radio v-model="radio" label="2" @change="selLable">{{$t('label_537')}}</el-radio>
									<div v-show="timeChange==1">
										<!-- <el-date-picker v-model="Readytime" type="monthrange" align="right" :clearable="false" format="yyyy-MM"
										 value-format="yyyy-MM" :range-separator="$t('label_264')" start-placeholder="开始月份" end-placeholder="结束月份" style='width:355px;'>
										</el-date-picker> -->
										<el-date-picker v-model="Readytime[0]" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
										 style='width:120px;'>
										</el-date-picker>
										<span style="margin: 0 5px;">{{$t('label_264')}}</span>
										<el-date-picker v-model="Readytime[1]" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM"
										 style='width:120px;'>
										</el-date-picker>
									</div>
									<div v-show="timeChange==2">
										<!-- <el-date-picker v-model="value1" type="datetimerange" :clearable="false" format="yyyy-MM-dd HH:mm"
										 value-format="yyyy-MM-dd HH:00:00" :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')" style='width:355px;'>
										</el-date-picker> -->
										<el-date-picker v-model="value1[0]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:00:00"
										 style='width:180px;'>
										</el-date-picker>
										<span style="margin: 0 5px;">{{$t('label_264')}}</span>
										<el-date-picker v-model="value1[1]" type="datetime" :clearable="false" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:00:00"
										 style='width:180px;'>
										</el-date-picker>
									</div>
									<div style="display: flex;align-items: center;margin-left: 80px">
										<p style="margin-right: 20px">{{$t('label_670')}}</p>
										<el-radio v-model="radios" label="1" @change="updateDataList">{{$t('label_74')}}</el-radio>
										<el-radio v-model="radios" label="2" @change="updateDataList">{{$t('label_647')}}</el-radio>
									</div>
<!--                  <div class="selectChoose">-->
<!--                    <div class="selectText">-->
<!--                      <p>设备编号</p>-->
<!--                    </div>-->
<!--                    <div class="select" style="width:350px">-->
<!--                      <el-input v-model="deviceCode" clearable></el-input>-->
<!--                    </div>-->
<!--                  </div>-->
								</div>
							</div>
						</div>
						<div class="buttonBox">
							<div>
								<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
							</div>
						</div>
					</div>
					<div class="overflowMes" style="height:calc(100vh - 270px)">
						<!--四个盒子-->
						<div class="lookdh">
							<div class="lookdh_one">
								<div>
									<i class="el-icon-picture-outline-round icon_style"></i>
								</div>
								<div class="left_mr">
									<div class="left_title_sss">{{$t('label_191')}}(%)</div>
									<div class="left_number">{{(dataList.activation>100?100:dataList.activation)}}</div>
								</div>
							</div>
							<div class="lookdh_two">
								<div>
									<i class="el-icon-coin icon_style"></i>
								</div>
								<div class="left_mr">
									<div class="left_title_sss">{{$t('label_609')}}({{radios=='1'?'h':$t('label_647')}})</div>
									<div class="left_number">{{updateTime((isNaN(dataList.loadTime)?0:dataList.loadTime))}}</div>
								</div>
							</div>
							<div class="lookdh_three">
								<div>
									<i class="el-icon-video-play icon_style"></i>
								</div>
								<div class="left_mr">
									<div class="left_title_sss">{{$t('label_613')}}</div>
									<div class="left_number">{{dataList.shutdownCount}}</div>
								</div>
							</div>
							<div class="lookdh_four">
								<div>
									<i class="el-icon-pie-chart icon_style"></i>
								</div>
								<div class="left_mr">
									<div class="left_title_sss">{{$t('label_617')}}({{radios=='1'?'h':$t('label_647')}})</div>
									<div class="left_number">{{updateTime((isNaN(dataList.shutdownTime)?0:dataList.shutdownTime))}}</div>
								</div>
							</div>
						</div>
						<!--稼动率状态图-->
						<div class="stateDiagram">
							<div class="sype_title">{{$t('label_625')}}</div>
							<div style="display: flex">
								<div style="display: flex;align-items: center">
									<div style="width: 20px;height: 20px;background: red;margin-right: 5px"></div>
									<div style="margin-right: 10px">{{$t('label_152')}}</div>
								</div>
								<div style="display: flex;align-items: center">
									<div style="width: 20px;height: 20px;background: #0353C1;margin-right: 5px"></div>
									<div style="margin-right: 10px">{{$t('label_191')}}</div>
								</div>
								<div style="display: flex;align-items: center">
									<div style="width: 20px;height: 20px;background: #AEADAD;margin-right: 5px"></div>
									<div>{{$t('label_621')}}</div>
								</div>
							</div>
						</div>
						<div style="width:98%;display: flex;align-items: center;justify-content: space-around">
							<!--统计图-->
							<div class="echart_style">
								<div id="main" style="width:850px;height: 200px;"></div>
							</div>
							<!--各种率-->
							<!-- <div class="box_rigth_lll">

								<div class="number_rigth">{{dataList.activation}}<span>%</span></div>
								<div>稼动率</div>
								<div class="container">
									<div class="skills hWidth"></div>
								</div>

								<div class="number_rigth" style="margin-top: 10px">{{dataList.maxActivation}}<span>%</span></div>
								<div>稼动率最大值</div>
								<div class="container">
									<div class="skills tWidth"></div>
								</div>

								<div class="number_rigth" style="margin-top: 10px">{{dataList.minActivation}}<span>%</span></div>
								<div>稼动率最小值</div>
								<div class="container">
									<div class="skills wWidth"></div>
								</div>
							</div> -->
							<div class="box_rigth_lll">
								<div class="number_rigth">{{(dataList.activation>100?100:dataList.activation)}}<span>%</span></div>
								<div style="margin-bottom:5px;">{{$t('label_191')}}</div>

								<el-progress color="#3fb393" :show-text="false" :stroke-width="8" :percentage="dataList.activation"></el-progress>

								<div class="number_rigth" style="margin-top:5px;">
                  {{
                    dataList.activation >= dataList.maxActivation ?
                      (dataList.activation >= 100?100:dataList.activation) :
                      (dataList.maxActivation >= 100?100:dataList.maxActivation)
                  }}
                  <span>%</span>
                </div>
								<div style="margin-bottom:5px;">{{$t('label_191')}}{{$t('label_659')}}</div>

								<el-progress color="#3fb393" :show-text="false" :stroke-width="8" :percentage="dataList.maxActivation"></el-progress>

								<div class="number_rigth" style="margin-top:5px;">
                  {{
                    dataList.activation <= dataList.minActivation ?
                      (dataList.activation >= 100?100:dataList.activation) :
                      (dataList.minActivation >= 100?100:dataList.minActivation)
                  }}
                  <span>%</span>
                </div>
								<div style="margin-bottom:5px;">{{$t('label_191')}}{{$t('label_661')}}</div>

								<el-progress color="#3fb393" :show-text="false" :stroke-width="8" :percentage="dataList.minActivation"></el-progress>

							</div>
						</div>
						<!--table区 align-items: center;-->
						<div class="echartKpi" style="width:100%;display: flex; height: 340px;">
							<!--左边开始-->
							<div class="box_down_left kpi">
								<div style="height: 50%;">
									<div style="color: #0C57C1;font-size: 14px;font-weight:600">{{$t('label_191')}}</div>
									<div class="tableBox_aaaa">
										<el-table :empty-text="$t('label_357')" ref="singleTable" :data="dataTableList.activationList" :header-cell-style="{'background-color': '#0353C1','color': '#ffffff',}"
										 highlight-current-row @current-change="handleCurrentChange" style="width: 100%" border>
											<el-table-column header-align="center" align="center" :label="$t('label_629')" type="index" width="60">
												<template slot-scope="scope">
													<div class="table_index_style" style="background: #0353C1;">{{scope.$index+1}}</div>
												</template>
											</el-table-column>
											<el-table-column property="name" :label="$t('label_593')"  min-width="210" align="center">
												<template slot-scope="scope">
													<span style="font-size: 14px; font-weight: 500; white-space: nowrap; cursor : pointer;">
														{{scope.row.code}} {{scope.row.name}}/{{scope.row.code}}{{'<'+scope.row.companyNumber+'>'}}/{{scope.row.superior}}
													</span>
													<!-- <popMesBox :popMes="scope.row.name+scope.row.code" :hoverMes="scope.row.name" :popWidth="280"></popMesBox> -->
												</template>
											</el-table-column>
											<el-table-column property="activation" min-width="90" :label="$t('label_191') + '(%)'" align="center">
												<template slot-scope="scope">
														{{(scope.row.activation>100?100:scope.row.activation)}}
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
								<!--异常停止次数-->
								<div style="height: 50%;">
									<div style="color: #FE0000;font-size: 14px;font-weight:600">{{$t('label_202')}}</div>
									<div class="tableBox_aaaa">
										<el-table :empty-text="$t('label_357')" ref="singleTable" :data="dataTableList.shutdownCountList" :header-cell-style="{'background-color': '#FE0000','color': '#ffffff',}"
										 highlight-current-row @current-change="handleCurrentChange" style="width: 100%" border>
											<el-table-column header-align="center" align="center" :label="$t('label_629')" type="index" width="60">
												<template slot-scope="scope">
													<div class="table_index_style" style="background: #FE0000">{{scope.$index+1}}</div>
												</template>
											</el-table-column>
											<el-table-column property="name" :label="$t('label_593')" min-width="210" align="center">
												<template slot-scope="scope">
													<span style="font-size: 14px; font-weight: 500; white-space: nowrap; cursor : pointer;">
														{{scope.row.code}} {{scope.row.name}}/{{scope.row.code}}{{'<'+scope.row.companyNumber+'>'}}/{{scope.row.superior}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="shutdownCount" min-width="90" :label="$t('label_202')" align="center">
											</el-table-column>
										</el-table>
									</div>
								</div>
							</div>
							<!--左边结束-->
							<!--中间饼状开始-->
							<div class="kpi " style="width: 26%">
								<div class="echart_styles" style="width: 100%">
									<div id="mains" style="width:330px;height: 310px"></div>
								</div>
								<div style="margin-left: 12px;">
									<div style="display: flex;align-items: center;justify-content: center">
										<div style="display: flex;align-items: center">
											<div style="width: 15px;height: 15px;margin-right: 5px" :style="{background:$store.getters.getColor['3'].color}"></div>
											<div style="margin-right: 10px;font-size: 12px">{{$t('label_841')}}</div>
										</div>

										<div style="display: flex;align-items: center">
											<div style="width: 15px;height: 15px;margin-right: 5px" :style="{background:$store.getters.getColor['2'].color}"></div>
											<div style="margin-right: 10px;font-size: 12px">{{$t('label_858')}}</div>
										</div>

<!--										<div style="display: flex;align-items: center">-->
<!--											<div style="width: 15px;height: 15px;margin-right: 5px" :style="{background:$store.getters.getColor['1'].color}"></div>-->
<!--											<div style="margin-right: 10px;font-size: 12px">{{$store.getters.getColor['1'].description}}</div>-->
<!--										</div>-->

										<div style="display: flex;align-items: center">
											<div style="width: 15px;height: 15px;margin-right: 5px" :style="{background:$store.getters.getColor['0'].color}"></div>
											<div style="margin-right: 10px;font-size: 12px">{{$t('label_843')}}</div>
										</div>
									</div>
								</div>
							</div>
							<!--饼状结束-->

							<!--右边开始-->
							<div class="box_down_rigth kpi">
								<div style="height: 50%;">
									<div style="color: #3FB393;font-size: 14px;font-weight:600;width: 100%;text-align: right">{{$t('label_609')}}</div>
									<div class="tableBox_aaaa">
										<el-table :empty-text="$t('label_357')" ref="singleTable" :data="dataTableList.loadTimeList" :header-cell-style="{'background-color': '#3FB393','color': '#ffffff',}"
										 highlight-current-row @current-change="handleCurrentChange" style="width: 100%" border>
											<el-table-column header-align="center" align="center" :label="$t('label_629')" type="index" width="60">
												<template slot-scope="scope">
													<div class="table_index_style" style="background: #3FB393">{{scope.$index+1}}</div>
												</template>
											</el-table-column>
											<el-table-column property="name" :label="$t('label_593')" min-width="210" align="center">
												<template slot-scope="scope">
													<span style="font-size: 14px; font-weight: 500; white-space: nowrap; cursor : pointer;">
														{{scope.row.code}} {{scope.row.name}}/{{scope.row.code}}{{'<'+scope.row.companyNumber+'>'}}/{{scope.row.superior}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="loadTime" min-width="90" :label="$t('label_609')+'(h)'" align="center">
												<template slot-scope="scope">
													<span style="font-size: 14px; font-weight: 500; white-space: nowrap; cursor : pointer;">
														{{updateTime(scope.row.loadTime)}}
													</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
								<!--异常停止次数-->
								<div style="height: 50%;">
									<div style="color: #fd0000;font-size: 14px;font-weight:600;width: 100%;text-align: right;">{{$t('label_617')}}</div>
									<div class="tableBox_aaaa">
										<el-table :empty-text="$t('label_357')" ref="singleTable" :data="dataTableList.shutdownTimeList" :header-cell-style="{'background-color': '#fd0000','color': '#ffffff',}"
										 highlight-current-row @current-change="handleCurrentChange" style="width: 100%" border>
											<el-table-column header-align="center" align="center" :label="$t('label_629')" type="index" width="60">
												<template slot-scope="scope">
													<div class="table_index_style" style="background: #fd0000">{{scope.$index+1}}</div>
												</template>
											</el-table-column>
											<el-table-column property="name" :label="$t('label_593')" min-width="210" align="center">
												<template slot-scope="scope">
													<span style="font-size: 14px; font-weight: 500; white-space: nowrap; cursor : pointer;">
														{{scope.row.code}} {{scope.row.name}}/{{scope.row.code}}{{'<'+scope.row.companyNumber+'>'}}/{{scope.row.superior}}
													</span>
												</template>
											</el-table-column>
											<el-table-column property="shutdownTime" min-width="90" :label="$t('label_617') + '(h)'" align="center">
												<template slot-scope="scope">
													<span style="font-size: 14px; font-weight: 500; white-space: nowrap; cursor : pointer;">
														{{updateTime(scope.row.shutdownTime)}}
													</span>
												</template>
											</el-table-column>
										</el-table>
									</div>
								</div>
							</div>
							<!--右边结束-->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts';
	import popMesBox from "@/components/list/popover/pop";
	import kpi from "@/assets/js/signal/kpi.js";
  import $ from 'jquery'
	export default {
		name: "kpiDetails",
		components: {
			popMesBox
		},
		data() {
			return {
				dataTableList: {},
				dataList: {},
				searchData: {
					beginTime: "",
					endTime: "",
					type: 2,
					id: 0,
				},
				workTime: {},
				Readytime: [], // 时间月
				value1: [], //日时间
				radios: '1', // 单位
				radio: '1', // 期间
				timeChange: '1', // 用来判断日期格式
				options: [{ // 排序列表
					value: '选项1',
					label: '移动率'
				}, {
					value: '选项2',
					label: '测试率'
				}],
				value: '选项1', // 排序默认
				tableDataTreeTime: [{
					warehouseName: '1'
				}],
				tableData: [{ // 稼动率
					name: '测试'
				}, {
					name: '测试1'
				}, {
					name: '测试1'
				}, {
					name: '测试1'
				}, {
					name: '测试1'
				}],
        // deviceCode: ''
			}
		},
		methods: {
			// 折线图
			myEcharts(data) {
				let date = data.dateList;
				let barData = data.dataAbnormalStopList;
				let lineData = data.activationList;
				let chartDom = document.getElementById('main');
				let myChart = echarts.init(chartDom);
				let option = {
					grid: { //改位置以及宽高
						top: '20%',
						left: '6%',
						right: '6%',
						bottom: '10%'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999'
							}
						}
					},
					xAxis: [{
						type: 'category',
						data: date,
						axisPointer: {
							type: 'shadow'
						},
						axisTick: { //去掉x轴刻度
							show: false,
						},
					}],
					yAxis: [{
							type: 'value',
							name: '(%)',
							min: 0,
							max: 100,
							interval: 20,
							axisLabel: {
								formatter: '{value}'
							},
							axisLine: { //去掉y轴线
								show: false
							},
							axisTick: { //去掉y轴刻度
								show: false,
							},
						},
						{
							type: 'value',
							name: '(' + this.$t('label_207') +')',
							min: 0,
							minInterval: 1,
							axisLabel: {
								formatter: '{value}'
							},
							axisLine: { //去掉y轴线
								show: false
							},
							axisTick: { //去掉y轴刻度
								show: false,
							},
							splitLine: { //去掉y轴网格
								show: false,
							},
						}
					],
					series: [{
							name: this.$t('label_191'),
							type: 'line',
							color: '#0353C1',
							symbol: "circle",
							symbolSize: 10,
							tooltip: {
								valueFormatter: function(value) {
									return (value>100?100:value) + ' %';
								}
							},
							markLine: {
								symbol: 'none',
								label: {
									show: false
								},
								data: [{
									yAxis: 80,
									silent: false,
									name: this.$t('label_621'),
									lineStyle: {
										type: "solid",
										color: "#aeadad",
										width: 2,
									}
								}]
							},
							data: lineData
						},
						{
							name: this.$t('label_152'),
							type: 'bar',
							color: '#ff0000',
							barMaxWidth: 40,
							yAxisIndex: 1,
							tooltip: {
								valueFormatter: (value) => {
									return value + ' ' + this.$t('label_207');
								}
							},
							data: barData
						}
					]
				}
				option && myChart.setOption(option);
			},
			// myEcharts(data) {
			// 	let chartDom = document.getElementById('main');
			// 	let myChart = echarts.init(chartDom);
			// 	let option;
			// 	option = {
			// 		grid: { //  改位置 以及宽高
			// 			top: '20%',
			// 			left: '5%',
			// 			right: '8%',
			// 			bottom: '10%'
			// 		},
			// 		tooltip: {
			// 			trigger: 'axis',
			// 			axisPointer: {
			// 				type: 'cross',
			// 				crossStyle: {
			// 					color: '#999'
			// 				}
			// 			}
			// 		},
			// 		xAxis: [{
			// 			show: true,
			// 			type: 'category',
			// 			data: data.dateList,
			// 			axisTick: { // 去掉x轴刻度
			// 				show: false,
			// 			},
			// 			color: '#B3B3B3',
			// 			axisPointer: {
			// 				type: 'shadow'
			// 			},
			// 			axisLabel: {
			// 				formatter: '{value}',
			// 				splitArea: {
			// 					show: false
			// 				},
			// 				axisTick: { //  去掉y轴刻度
			// 					show: false
			// 				},
			// 				color: '#B3B3B3',
			// 				axisLine: {
			// 					lineStyle: {
			// 						color: '#B3B3B3',
			// 						width: 1, //x轴线的宽度
			// 					}
			// 				},
			// 				fontSize: 16,
			// 			}
			// 		}],
			// 		yAxis: [{
			// 				show: true,
			// 				splitLine: {
			// 					show: false
			// 				},
			// 				type: 'value',
			// 				name: '(%)',
			// 				nameTextStyle: {
			// 					color: '#B3B3B3',
			// 					fontSize: 16,
			// 				},
			// 				color: '#B3B3B3',
			// 				min: 0,
			// 				max: 100,
			// 				interval: 20,
			// 				axisTick: {
			// 					show: false
			// 				},
			// 				axisLabel: {
			// 					formatter: '{value}',
			// 					splitArea: {
			// 						show: false
			// 					},
			// 					axisTick: { //  去掉y轴刻度
			// 						show: true
			// 					},
			// 					textStyle: {
			// 						color: '#B3B3B3'
			// 					},
			// 					axisLine: {
			// 						lineStyle: {
			// 							color: '#B3B3B3',
			// 							width: 1, //x轴线的宽度
			// 						}
			// 					},
			// 					fontSize: 16,
			// 				}
			// 			}, {
			// 				axisLine: {
			// 					show: false
			// 				},
			// 				type: 'value',
			// 				// min: 0,
			// 				// max: 40,
			// 				// interval: 10,
			// 				axisTick: { //  去掉刻度线
			// 					show: false
			// 				},
			// 				axisLabel: {
			// 					formatter: '{value}',
			// 					color: '#B3B3B3',
			// 					fontSize: 16,

			// 				}
			// 			},

			// 		],
			// 		series: [{
			// 				name: '异常停止次数',
			// 				type: 'bar',
			// 				data: data.dataAbnormalStopList,
			// 				yAxisIndex: 1,
			// 				barWidth: 30,
			// 				itemStyle: { //柱状颜色和圆角
			// 					color: '#ff0000'
			// 				},
			// 			},
			// 			{
			// 				name: '稼动率',
			// 				type: 'line',
			// 				yAxisIndex: 0,
			// 				data: data.activationList,
			// 				markLine: {
			// 					symbol: "none",
			// 					label: {
			// 						show: false //将警示值放在哪个位置，三个值“start”,"middle","end"  开始  中点 结束
			// 					},
			// 					data: [{
			// 						silent: false, //鼠标悬停事件  true没有，false有
			// 						lineStyle: { //警戒线的样式  ，虚实  颜色
			// 							type: "solid",
			// 							color: "#D0D0D0",
			// 							width: 3,
			// 						},
			// 						yAxis: 80 // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
			// 					}]
			// 				},
			// 				itemStyle: { //柱状颜色和圆角
			// 					color: '#5681BF'
			// 				},
			// 			},
			// 		]
			// 	};
			// 	option && myChart.setOption(option);
			// },
			// 饼状图
			myEchartss() {
				let chartDom = document.getElementById('mains');
        let myChart = echarts.init(chartDom);
        let option;
        let color1 = this.$store.getters.getColor['3'].color
        let color2 = this.$store.getters.getColor['2'].color
        let color3 = this.$store.getters.getColor['1'].color
				let color4 = this.$store.getters.getColor['0'].color;
				option = {
					title: {
						left: 'center',
						text: this.$t('label_561') + this.$t('label_412'),
						y: '30',
						top: 0,
					},
					tooltip: {
						trigger: 'item'
					},
					color: [color1, color2, color3, color4], // 对应的颜色
					series: [{
						type: 'pie',
						radius: '60%',
						center: ["50%", "50%"], // 上 下 左  右 位置
						data: this.dataList.pie,
						emphasis: { //高亮状态
							label: {
								show: true,
								fontSize: '15',
							}
						},
						label: {
							normal: { //图形默认状态
								show: true,
								textStyle: {
									fontWeight: 500,
									fontSize: 14,
									color: '#4A4A4A'
								},
								formatter: '{d}%'
							},
							distanceToLabelLine: 0,
							padding: [0, 0, 0, 0],
						},
						labelLine: {
							length: 7
						},
						clockwise: false, //生长方向，是否顺时针
					}]
				};
        /*let widthChart = $('.echartKpi').innerWidth()*0.26;
        console.log(widthChart)
        option.resize({width:widthChart})*/
        /*myChart.resize({width: $('.echartKpi').width})*/
				option && myChart.setOption(option);
			},
			handleCurrentChange(val) {
				console.log(val);
			},
			//最後一天
			getday(val, index) {
				let nextMonthFirstDay = new Date(val.substring(0, 4), val.substring(5, 7), 1);
				let oneDay = 1000 * 60 * 60 * 24;
				if (index == 1) {
					let lastTime = new Date(nextMonthFirstDay);
				} else {
					let lastTime = new Date(nextMonthFirstDay - oneDay);
				}
				let day = lastTime.getDate();
				let month = parseInt(lastTime.getMonth() + 1);
				if (month < 10) {
					month = '0' + month
				}
				if (day < 10) {
					day = '0' + day
				}
				return lastTime.getFullYear() + '-' + month + '-' + day + ' ';
			},
			//查询
			search() {
			  // this.$set(this.searchData, 'code', this.deviceCode);
				if (this.radio == '1') { //月
					//开始时间
					// if (this.workTime.beginTimeOverDay == 0) { //0不跨天；1跨天
					// 	this.searchData.beginTime = this.Readytime[0];
					// } else {
					this.searchData.beginTime = this.Readytime[0];
					this.searchData.endTime = this.Readytime[1];
					// }
					//结束时间
					// if (this.workTime.endTimeOverDay == 0) { //0不跨天；1跨天
					// 	this.searchData.endTime = this.getday(this.Readytime[1], 0);
					// } else {
					// 	this.searchData.endTime = this.getday(this.Readytime[1], 0);
					// }
					kpi.selectDetailOperative(this.searchData).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dataList = data.data
							this.myEcharts(data.data); //  柱状图
							this.updateDataList();
							// this.selectDataEventListList = data.data.records
						}
					}).catch((response) => {
						console.log(response)
					})
					kpi.selectDetailOperativeList(this.searchData).then((response) => {
						const data = response.data;
						if (data.code == "1") {

							this.dataTableList = data.data
						}
					}).catch((response) => {
						console.log(response)
					})
				} else { //日
					//开始时间
					this.searchData.beginTime = this.value1[0];
					//结束时间
					this.searchData.endTime = this.value1[1];
					kpi.selectDetailOperativeDay(this.searchData).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dataList = data.data
							this.myEcharts(data.data);
							this.updateDataList(); //  柱状图
							// this.selectDataEventListList = data.data.records
						}
					}).catch((response) => {
						console.log(response)
					})
					kpi.selectDetailOperativeDayList(this.searchData).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dataTableList = data.data
						}
					}).catch((response) => {
						console.log(response)
					})
				}
				// let param = {
				// 	pageNum: 1,
				// 	pageSize: this.pageSize,
				// }
				// this.searchPage(param)

			},
			// 点击单选框 月  1
			selLables(val) {
				this.timeChange = val
				this.initDate();
			},
			// 点击单选框  日 2
			selLable(val) {
				this.timeChange = val
				this.value1 = [this.workTime.beginTime.substring(0, 13) + ':00:00', this.updatetime(this.workTime.endTime)
				];
			},
			updatetime(num) {
				let sdd = new Date(num);
				let yyyy = sdd.getFullYear();
				let MM = sdd.getMonth() + 1 < 10 ? '0' + (sdd.getMonth() + 1) : sdd.getMonth() + 1
				let dd = sdd.getDate() < 10 ? '0' + sdd.getDate() : sdd.getDate()
				let HH = (sdd.getHours()+1) < 10 ? '0' + (sdd.getHours()+1) : (sdd.getHours()+1)
				// let mm = sdd.getMinutes() < 10 ? '0' + sdd.getMinutes() : sdd.getMinutes()
				// let ss = sdd.getSeconds() < 10 ? '0' + sdd.getSeconds() : sdd.getSeconds()
				return yyyy + "-" + MM + '-' + dd + ' ' + HH + ':' + '00:00'
			},
			//初始化时间
			initDate: function() {
				let date = new Date();
				let seperator = "-";
				let year = date.getFullYear();
				let month = date.getMonth() + 1;
				let day = date.getDate();
				let currentMonth = year + seperator + this.zero(month);
				let currentDay = year + seperator + this.zero(month) + seperator + this.zero(day) + ' 00:00';
				this.Readytime = [currentMonth, currentMonth];

			},
			//补0
			zero: function(i) {
				return i > 9 ? i : '0' + i;
			},

			newMes(data, workTime, code) {
				this.workTime = workTime;
				console.log("eld", this.searchData.type);
				this.searchData.type = data.type;
				console.log("new", data)
				this.searchData.id = data.id;
				// this.deviceCode = code;
				this.initDate();
				this.search();
			},
			updateTime(item) {
				if (this.radios == '1') {
					return Math.trunc(item / 3600000)
				} else {
					return Math.trunc(item / 60000)
				}
			},
			updateDataList() {
				if (this.radios == '1') {
					for (let i = 0; i < this.dataList.pie.length; i++) {
						this.dataList.pie[i].value = Math.trunc(this.dataList.pie[i].value2 / 3600000)
            this.dataList.pie[i].name = this.$t(this.dataList.pie[i].name)
					}
				} else {
					for (let i = 0; i < this.dataList.pie.length; i++) {
						this.dataList.pie[i].value = Math.trunc(this.dataList.pie[i].value2 / 60000)
            this.dataList.pie[i].name = this.$t(this.dataList.pie[i].name)
					}
				}
				this.myEchartss();
			}
		},
		mounted() {
			this.myEchartss() // 饼状图
		}
	}
</script>

<style>

  .overflowMes{
    overflow: auto;
    min-width: 1100px;
  }
	.kpi .echart_styles {
		width: 95%;
		height: 290px;
	}

	.kpi .tableBox_aaaa {
		margin-top: 0px;
	}

	.kpi .tableBox_aaaa .el-table td,
	.kpi .tableBox_aaaa .el-table th {
		padding: 0;
	}

	.box_rigth_lll {
		width: 180px;
		height: 201px;
		background: #EFEFEF;
		border: 1px #CACACA solid;
		padding: 3px 20px 3px 20px;
		box-sizing: border-box;
	}

	.lookdh {
		width: 100%;
		display: flex;
		align-items: center;
	}

	.lookdh_one {
		width: 24%;
		margin-right: 10px;
		height: 60px;
		background: #0353C1;
		display: flex;
		align-items: center;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.lookdh_two {
		width: 24%;
		margin-right: 10px;
		height: 60px;
		background: #3FB393;
		display: flex;
		align-items: center;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.lookdh_three {
		width: 24%;
		margin-right: 10px;
		height: 60px;
		background: #FE0000;
		display: flex;
		align-items: center;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.lookdh_four {
		width: 24%;
		margin-right: 10px;
		height: 60px;
		background: #FE0000;
		display: flex;
		align-items: center;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.icon_style {
		color: #FFFFFF;
		font-size: 40px;
	}

	.left_mr {
		margin-left: 20px;
	}

	.left_title_sss {
		color: #FFFFFF;
		font-size: 15px;
	}

	.left_number {
		color: #FFFFFF;
		font-size: 25px;
		font-weight: bold;
	}

	.stateDiagram {
		width: 98%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 5px;
	}

	.sype_title {
		font-size: 18px;
		font-weight: bold;
	}

	.number_rigth {
		font-size: 16px;
		font-weight: bold;
	}

	.container {
		width: 100%;
		height: 10px;
		border-radius: 20px;
		background-color: #D0D0D0;
	}

	/*
// 根据后端返回的百分比替换width
*/
	.hWidth {
		width: 42.1%;
		height: 10px;
		border-radius: 20px;
		background-color: #3FB393;
	}

	.tWidth {
		width: 73.3%;
		height: 10px;
		border-radius: 20px;
		background-color: #3FB393;
	}

	.wWidth {
		width: 10%;
		height: 10px;
		border-radius: 20px;
		background-color: #3FB393;
	}

	.box_down_left {
		width: 37%;
		height: 100%;
	}

	.box_down_rigth {
		width: 37%;
	}

	.table_index_style {
		width: 15px;
		height: 15px;
		color: #ffffff;
		font-size: 12px;
		line-height: 15px;
		border-radius: 2px;
		font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/components/list/KPI/kpiDetails.vue